export { default } from "./ClassNameGenerator.mjs";